module.exports = __webpack_public_path__ + "static/media/Erase.3cd753db.jpeg";